import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Footer from '../Footer/FooterContainer';
import FinancialPlanHeader from '../FinancialPlanHeaderView';
import ActionStepsV2 from '../ActionStepsV2/ActionStepsV2Container';
import Explanations from '../Explanations/ExplanationsContainer';
import HealthCareChart from '../../HealthCareChart/HealthCareChartContainer';
import { ASSUMPTIONS, OVERVIEW } from '../Explanations/ExplanationsConst';
import AssumptionsSectionView from '../Components/AssumptionsTable';
import healthCareAssumptionsLabel from './HealthCareAssumptionsConts';
import GeneralAssumptionsView from '../GeneralAssumptions';
import { Tasks } from '../../FinancialPlanOPL/Goals/components/Tasks/Tasks';

class HealthCare extends Component {
  render() {
    const {
      clientId,
      fpId,
      data,
      chartData,
      chartTitle,
      isPrint,
      hasGoal,
      selectedSection,
      assumptionsValues,
      goalId,
    } = this.props;

    if (!hasGoal) {
      return null;
    }

    return (
      <div className="NewFinancialPlan_retirement">
        <div
          className={`NewFinancialPlan_header
              ${!this.props.showCalibration ? ' hide-calibration-button' : ''}
          `}
        >
          <FinancialPlanHeader
            {...this.props}
            hideOldDescription={false}
            hideTrackIndicator={selectedSection === ASSUMPTIONS && isPrint}
          />
        </div>
        <section className="calibration" />
        {!isPrint && <Explanations clientId={clientId} />}
        {selectedSection === OVERVIEW && (
          <section>
            <HealthCareChart
              isPrint={isPrint}
              clientId={clientId}
              Data={chartData}
              chartTitle={chartTitle}
              loaded
            />
          </section>
        )}
        {selectedSection === ASSUMPTIONS && !isPrint && (
          <div className="assumptions-container">
            <AssumptionsSectionView
              title="Health Care Goal Assumptions"
              valuesList={assumptionsValues}
              labelList={healthCareAssumptionsLabel}
            />
            <br />
            <GeneralAssumptionsView clientId={clientId} />
          </div>
        )}

        {!isPrint && selectedSection !== ASSUMPTIONS && <Tasks />}

        {isPrint && selectedSection !== ASSUMPTIONS && (
          <ActionStepsV2 clientId={clientId} fpId={fpId} goalId={goalId} />
        )}

        {!isPrint && <Footer data={data} clientId={clientId} fpId={fpId} />}
      </div>
    );
  }
}

HealthCare.defaultProps = {
  calibration: null,
  isPrint: false,
  isCalibrating: false,
};

HealthCare.propTypes = {
  showCalibration: PropTypes.bool.isRequired,
  data: PropTypes.shape({}).isRequired,
  calibration: PropTypes.shape({}),
  clientId: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  goalId: PropTypes.string.isRequired,
  isCalibrating: PropTypes.bool,
  selectedGoal: PropTypes.shape({}).isRequired,
  setReactCalibrationWidget: PropTypes.func.isRequired,
  chartData: PropTypes.shape({}).isRequired,
  chartTitle: PropTypes.string.isRequired,
  isPrint: PropTypes.bool,
  hasGoal: PropTypes.bool.isRequired,
};

export default HealthCare;
